// extracted by mini-css-extract-plugin
export default {"dragWords":"DragWords_dragWords__Hke7U","words":"DragWords_words__n+KMu","text":"DragWords_text__xVZSu"};